export default {
  state: {
    gitIgnoreTemplates: null,
    gitlabOwnedProjects: null,
    gitlabImportedProjects: null,
    gitlabProjectsToImport: [],
    gitlabProjectsWithChanges: []
  },
  mutations: {
    setGitIgnoreTemplates(state, payload) {
      state.gitIgnoreTemplates = { ...payload };
    },
    setGitlabOwnedProjects(state, payload) {
      state.gitlabOwnedProjects = payload;
    },
    setGitlabImportedProjects(state, payload) {
      state.gitlabImportedProjects = { ...payload };
    },
    setGitlabProjectsToImport(state, payload) {
      let index = state.gitlabProjectsToImport.findIndex((item) => item.id === payload.projectId);

      if (payload.checkboxValue) {
        if (index === -1) {
          state.gitlabProjectsToImport.push(payload.project);
        }
      } else if (index !== -1) {
        state.gitlabProjectsToImport.splice(index, 1);
      }
    },
    setGitlabProjectsWithChanges(state, payload) {
      let indexInListOfProjects =
        state.gitlabOwnedProjects._embedded.gitlabProjectPreviewModelList.findIndex(
          (item) => item.id === payload.projectId
        );

      let indexInListOfProjectsWithChanges = state.gitlabProjectsWithChanges.findIndex(
        (item) => item.id === payload.projectId
      );

      if (indexInListOfProjects !== -1) {
        if (indexInListOfProjectsWithChanges === -1) {
          state.gitlabProjectsWithChanges.push(payload.project);
        } else {
          state.gitlabProjectsWithChanges[indexInListOfProjectsWithChanges] = payload.project;
        }
      }
    }
  },
  actions: {
    setGitIgnoreTemplates(state, payload) {
      state.commit('setGitIgnoreTemplates', payload);
    },
    setGitlabOwnedProjects(state, payload) {
      state.commit('setGitlabOwnedProjects', payload);
    },
    setGitlabImportedProjects(state, payload) {
      state.commit('setGitlabImportedProjects', payload);
    },
    setGitlabProjectsToImport(state, payload) {
      state.commit('setGitlabProjectsToImport', payload);
    },
    setGitlabProjectsWithChanges(state, payload) {
      state.commit('setGitlabProjectsWithChanges', payload);
    }
  },
  getters: {
    getGitIgnoreTemplates(state) {
      return state.gitIgnoreTemplates;
    },
    getGitlabOwnedProjects(state) {
      return state.gitlabOwnedProjects;
    },
    getGitlabImportedProjects(state) {
      return state.gitlabImportedProjects;
    },
    getGitlabProjectsToImport(state) {
      return state.gitlabProjectsToImport;
    },
    getGitlabProjectsWithChanges(state) {
      return state.gitlabProjectsWithChanges;
    },
    getCertainGitlabProjectForImport: (state) => (projectId) =>
      state.gitlabProjectsToImport.findIndex((item) => item.id === projectId),
    
    getCertainGitlabProjectWithChanges: (state) => (projectId) => {
      const index = state.gitlabProjectsWithChanges.findIndex((item) => item.id === projectId);
      return state.gitlabProjectsWithChanges[index]?.submitForm || null;
    }
      
  }
};
